import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const Modal = () => (
  <ComponentDocs
    name="<Modal/>"
    entry="Modal"
    propsEntry="ModalProps"
    externalProps={ExternalProps.MuiDialog}
  >
    <ComponentExample
      name="Modal templates"
      import={import("examples/Modals/Modal/ModalTemplatesExample")}
      rawImport={import("examples/Modals/Modal/ModalTemplatesExample?raw")}
    />
    <ComponentExample
      name="Custom actions"
      import={import("examples/Modals/Modal/CustomActionsExample")}
      rawImport={import("examples/Modals/Modal/CustomActionsExample?raw")}
    />
    <ComponentExample
      name="Moveable modal"
      import={import("examples/Modals/Modal/MoveableModalExample")}
      rawImport={import("examples/Modals/Modal/MoveableModalExample?raw")}
    />
  </ComponentDocs>
);

export default Modal;
